// mock地址
const mockService = "http://mock.o-wu.com/mock/5d9fe56957a4f01beaab5ed1/class";
const testFinalCoursewareApiService = "https://final-courseware-api.caihonggou.com";
const testFinalAdminApiService = "https://final-admin-api.caihonggou.com";
const prodFinalCoursewareApiService = "https://final-courseware-api.aikaola.com";
const prodFinalAdminApiService = "https://final-admin-api.aikaola.com";
const devUcenterService = 'https://ucenter.yunkeduntest.com'
const testUcenterService = 'https://ucenter.yunkeduntest.com'
const prodUcenterService = 'https://ucenter.yunkedun.com'
const devLoginUrl = 'https://ucenter.yunkeduntest.com/oauth/authorize?client_id=2&redirect_uri=http://localhost&response_type=token&scope=&state='
const testLoginUrl = 'https://ucenter.yunkeduntest.com/oauth/authorize?client_id=11&redirect_uri=https://editor.courseware.yunkeduntest.com&response_type=token&scope=&state=autoparamters'
const prodLoginUrl = 'https://ucenter.yunkedun.com/oauth/authorize?client_id=11&redirect_uri=https://editor.courseware.yunkedun.com&response_type=token&scope=&state=autoparamters'

const devLoginOut = 'https://ucenter.yunkeduntest.com/sso/logout?client_id=2&redirect_uri=https//localhost&response_type=token&scope=&state=autoparamters'
const testLoginOut = 'https://ucenter.yunkeduntest.com/sso/logout?client_id=11&redirect_uri=https://editor.courseware.yunkeduntest.com&response_type=token&scope=&state=autoparamters'
const prodLoginOut = 'https://ucenter.yunkedun.com/sso/logout?client_id=11&redirect_uri=https://editor.courseware.yunkedun.com&response_type=token&scope=&state=autoparamters'

const devLoginOutPlat = `${devUcenterService}/sso/logout?client_id=2&redirect_uri=http://localhost&response_type=token&scope=&state=autoparamters`
const testLoginOutPlat = `${testUcenterService}/sso/logout?client_id=14&redirect_uri=https://management.schoolcenter.yunkeduntest.com&response_type=token&scope=&state=autoparamters`
const prodLoginOutPlat = `${prodUcenterService}/sso/logout?client_id=14&redirect_uri=https://management.schoolcenter.yunkedun.com&response_type=token&scope=&state=autoparamters`

export const devPublicUrl = {
  mockService,
  finalCoursewareApiService: testFinalCoursewareApiService,
  finalAdminApiService: testFinalAdminApiService,
  ucenterService: devUcenterService,
  loginUrl: devLoginUrl,
  loginOut: devLoginOut,
  loginOutPlat: devLoginOutPlat
};

// 测试版公网IP-URL
export const testPublicUrl = {
  mockService,
  finalCoursewareApiService: testFinalCoursewareApiService,
  finalAdminApiService: testFinalAdminApiService,
  ucenterService: testUcenterService,
  loginUrl: testLoginUrl,
  loginOut: testLoginOut,
  loginOutPlat: testLoginOutPlat
};

// 发布版公网地址-URL
export const prodPublicUrl = {
  mockService,
  finalCoursewareApiService: prodFinalCoursewareApiService,
  finalAdminApiService: prodFinalAdminApiService,
  ucenterService: prodUcenterService,
  loginUrl: prodLoginUrl,
  loginOut: prodLoginOut,
  loginOutPlat: prodLoginOutPlat
};
